const defaultOptions = {
  lang: '',
  url: '',
  title: '',
  description: '',
  canonical: '',
  general: ``,
  facebook: ``,
  twitter: ``,
}

export const head = customOptions => {
  const defaultScripts = [
    {
      src: 'https://static.hotmart.com/hot-lgpd/lgdpscript.min.js',
      defer: true,
    },
    {
      type: 'application/ld+json',
      json: customOptions.breadcrumbs,
    },
  ]

  const options = Object.assign({}, defaultOptions, customOptions)
  const title = options.title
  const script = customOptions.script ? [...defaultScripts, ...customOptions.script] : defaultScripts
  const htmlAttrs = customOptions.htmlAttrs
  const link = customOptions.link

  const head = {
    htmlAttrs: { ...htmlAttrs },
    title,

    title: options.title,

    meta: [
      // Share - General
      { hid: 'url', itemprop: 'url', content: options.url },
      { hid: 'description', name: 'description', content: options.description },
      { hid: 'author', name: 'author', content: 'Hotmart' },
      { hid: 'image', itemprop: 'image', content: options.general },

      // Share - Facebook
      { hid: 'og:type', property: 'og:type', content: 'website' },
      { hid: 'og:title', property: 'og:title', content: options.title },
      { hid: 'og:description', property: 'og:description', content: options.description },
      { hid: 'og:image', property: 'og:image', content: options.facebook },
      { hid: 'og:site_name', property: 'og:site_name', content: options.title },
      { hid: 'og:locale', property: 'og:locale', content: options.lang },
      { hid: 'og:url', property: 'og:url', content: options.url },

      // Share - Twitter
      { hid: 'twitter:card', name: 'twitter:card', content: 'summary' },
      { hid: 'twitter:site', name: 'twitter:site', content: '@hotmart' },
      { hid: 'twitter:creator', name: 'twitter:creator', content: '@hotmart' },
      { hid: 'twitter:url', name: 'twitter:url', content: options.url },
      { hid: 'twitter:title', name: 'twitter:title', content: options.title },
      { hid: 'twitter:description', name: 'twitter:description', content: options.description },
      { hid: 'twitter:image', name: 'twitter:image', content: options.twitter },
    ],
    script,
    link: [...link, { rel: 'canonical', href: options.canonical }],
  }

  return head
}

export default {
  head,
}
